<template>
  <div class="v-wrap">

    <div class="v-controls">
      <ring-category-nav class="v-controls__category" />

      <div class="v-controls__filter">
        <filter-accordion v-show="metals.length || textures.length || types.length">

          <div v-if="!( ['/set_rings'].includes($pathname) )">
            <div v-if="favorite_rings_url" class="v-favoriteLink mb-3">
              <a :href="favorite_rings_url">{{ $t("FilterAccordion.favoritedRings") }}</a>
            </div>
          </div>

          <filter-list
            v-if="designs.length"
            :listTitle="$t('FilterList.listTitle.design')"
            :list="designs"
            :selectedList="selectedDesigns"
            @itemClick="(e, v) => { onItemClick(e, v, 'selectedDesigns') }"
          />

          <filter-list
            v-if="metals.length"
            :listTitle="$t('FilterList.listTitle.bullion')"
            :list="metals"
            :selectedList="selectedMetals"
            @itemClick="(e, v) => { onItemClick(e, v, 'selectedMetals') }"
          />

          <filter-list
            v-if="tanzos.length"
            :listTitle="$t('FilterList.listTitle.forged')"
            :list="tanzos"
            :selectedList="selectedTanzos"
            @itemClick="(e, v) => { onItemClick(e, v, 'selectedTanzos') }"
          />

          <filter-list
            v-if="textures.length"
            :listTitle="$t('FilterList.listTitle.texture')"
            :list="textures"
            :selectedList="selectedTextures"
            @itemClick="(e, v) => { onItemClick(e, v, 'selectedTextures') }"
          />

          <filter-list
            v-if="diamonds.length"
            :listTitle="$t('FilterList.listTitle.diamond')"
            :list="diamonds"
            :selectedList="selectedDiamonds"
            @itemClick="(e, v) => { onItemClickSetOne(e, v, 'selectedDiamonds') }"
          />

          <filter-list
            v-if="types.length"
            :listTitle="$t('FilterList.listTitle.type')"
            :list="types"
            :selectedList="selectedTypes"
            @itemClick="(e, v) => { onItemClick(e, v, 'selectedTypes') }"
          />

          <filter-list
            v-if="ec.length"
            :listTitle="$t('FilterList.listTitle.ec')"
            :list="ec"
            :selectedList="selectedEc"
            @itemClick="(e, v) => { onItemClick(e, v, 'selectedEc') }"
          />

          <div
            v-show="metals.length || textures.length || types.length"
          >
            <button class="v-button" @click="onClearClick">{{ $t("FilterAccordion.clear") }}</button>
          </div>
        </filter-accordion>
      </div>

      <div
        class="v-controls__switchImgs v-photoButtons"
      >
      <button
          :title="$t('Main.photoButtons.imageTitle1')"
          :class="['v-button', photoMode === 'single_color_bg' ? 'is-selected' : '']"
          data-ga-event-name="switch_images" data-ga-event-area="collection_controls" data-ga-event-value="single_color_bg"
          @click="photoMode = 'single_color_bg'; bgMode = ''"
          v-if="( ['/set_rings'].includes($pathname) )"
        >{{ $t("Main.photoButtons.image1") }}</button>
        <button
          :title="$t('Main.photoButtons.imageTitle1')"
          :class="['v-button', photoMode === 'main' ? 'is-selected' : '']"
          data-ga-event-name="switch_images" data-ga-event-area="collection_controls" data-ga-event-value="main"
          @click="photoMode = 'main'; bgMode = ''"
          v-if="!( ['/set_rings', '/favorite_rings'].includes($pathname) )"
        >{{ $t("Main.photoButtons.image1") }}</button>
        <button
          title="商品画像を「画像2」に切り替える"
          :class="['v-button', photoMode === 'sub' ? 'is-selected' : '']"
          data-ga-event-name="switch_images" data-ga-event-area="collection_controls" data-ga-event-value="sub"
          @click="photoMode = 'sub'; bgMode = ''"
          v-if="!( ['/set_rings', '/favorite_rings'].includes($pathname) )"
        >{{ $t("Main.photoButtons.image2") }}</button>
        <button
          title="商品画像を「着用写真」に切り替える"
          :class="['v-button', photoMode === 'hand' ? 'is-selected' : '']"
          data-ga-event-name="switch_images" data-ga-event-area="collection_controls" data-ga-event-value="hand"
          @click="photoMode = 'hand'; bgMode = ''"
          v-if="!( ['/favorite_rings'].includes($pathname) )"
        >{{ $t("Main.photoButtons.worn") }}</button>
      </div>
    </div>

    <div class="v-results">
      <router-view
        :key="$route.fullPath"
        :currentPage="currentPage"
        :selectedDesigns="selectedDesigns"
        :selectedMetals="selectedMetals"
        :selectedTanzos="selectedTanzos"
        :selectedTextures="selectedTextures"
        :selectedDiamonds="selectedDiamonds"
        :selectedTypes="selectedTypes"
        :selectedEc="selectedEc"
        :photoMode="photoMode"
        :bgMode="bgMode"
        @incrementCurrentPage="currentPage = currentPage + 1"
      />
    </div>

  </div>
</template>

<script>
import { Http } from '../../../http'
import FilterList from './FilterList.vue'
import FilterAccordion from './FilterAccordion.vue'
import RingCategoryNav from './RingCategoryNav.vue'


export default {
  name: 'Main',

  components: { FilterList, RingCategoryNav, FilterAccordion, },

  data () {
    return {
      designs: [],
      selectedDesigns: [],
      metals: [],
      selectedMetals: [],
      tanzos: [],
      selectedTanzos: [],
      textures: [],
      selectedTextures: [],
      diamonds: [],
      selectedDiamonds: [],
      types: [],
      selectedTypes: [],
      ec: [],
      selectedEc: [],
      currentPage: 1,
      photoMode: "single_color_bg", // "main"
      bgMode: "", // ""
      isFilterListOpen: false,
      favorite_rings_url: null,
    }
  },

  watch: {
    '$route': {
      immediate: true,
      deep: true,
      handler (to, from) {
        const names = [
          { tagName: "design[]", dataName: "selectedDesigns" },
          { tagName: "metal[]", dataName: "selectedMetals" },
          { tagName: "tanzo[]", dataName: "selectedTanzos" },
          { tagName: "texture[]", dataName: "selectedTextures" },
          { tagName: "diamond[]", dataName: "selectedDiamonds" },
          { tagName: "type[]", dataName: "selectedTypes" },
          { tagName: "ec[]", dataName: "selectedEc" },
        ]

        names.forEach((n) => {
          if ( to.query[n.tagName] && Array.isArray(to.query[n.tagName]) ) {
            this[n.dataName] = JSON.parse(JSON.stringify(to.query[n.tagName]))
          } else if ( to.query[n.tagName] ) {
            this[n.dataName] = [ to.query[n.tagName] ] || []
          } else {
            this[n.dataName] = []
          }
        })

        this.currentPage = 1
        if (to.query["page"]) {
          this.currentPage = Number.parseInt(to.query["page"])
        }
      },
    },
  },

  methods: {
    setParamForRingImgs () {
      if ([].includes(this.$pathname)) {
        this.photoMode = "main"
        this.bgMode = ""
      }
    },
    onItemClick (e, v, dataName) {
      if (this[dataName].includes(v)) {
        this[dataName] = this[dataName].filter(t => t !== v)
      } else {
        this[dataName] = this[dataName].concat(v)
      }

      this.pushRoute()
    },
    onItemClickSetOne (e, v, dataName) {
      if (this[dataName].includes(v)) {
        this[dataName] = this[dataName].filter(t => t !== v)
      } else {
        this[dataName] = [v]
      }

      this.pushRoute()
    },
    onClearClick (e) {
      this.selectedDesigns = []
      this.selectedMetals = []
      this.selectedTanzos = []
      this.selectedTextures = []
      this.selectedDiamonds = []
      this.selectedTypes = []
      this.selectedEc = []

      this.pushRoute()
    },
    onFilterToggleClick (e) {
      this.isFilterListOpen = !this.isFilterListOpen;
    },
    pushRoute () {
      const query = {
        'design[]': this.selectedDesigns,
        'metal[]': this.selectedMetals,
        'tanzo[]': this.selectedTanzos,
        'texture[]': this.selectedTextures,
        'diamond[]': this.selectedDiamonds,
        'design[]': this.selectedDesigns,
        'type[]': this.selectedTypes,
        'ec[]': this.selectedEc,
        'debug': this.$route.query.debug,
        'photoMode': this.$route.query.photoMode,
      }
      this.$router.push({
        path: "/",
        query: query,
      }) .catch(err => {})
    },
  },

  created () {
    const url = `/api/collections/tags`
    const pathname = this.$pathname
    const queryParams = this.$router.resolve({
      path: '',
      query: this.$route.query,
    }).resolved.fullPath.substring(1)
    this.setParamForRingImgs()
    Http.get(url + pathname + queryParams)
      .then(response => {
        this.designs = response.data.designs || []
        this.metals = response.data.metals || []
        this.tanzos = response.data.tanzos || []
        this.textures = response.data.textures || []
        this.diamonds = response.data.diamonds || []
        this.types = response.data.types || []
        this.ec = response.data.ec || []
        this.favorite_rings_url = response.data.favorite_rings_url
        if (response.data.locale) { this.$i18n.locale = response.data.locale }
      })
  },
}
</script>

<style lang="scss">
.v-button {
  color: inherit;
  text-align: center;
  display: flex;
  justify-content: center;
  align-items: center;
  font-size: 10px;
  border: 1px solid rgba(214, 214, 214, .5);
  border-radius: 2px;
  text-decoration: none;
  min-height: 40px;
  padding: 5px;
  background: transparent;
  width: -webkit-fill-available;

  &.is-selected {
    background: #2a475a;
    border-color: #2a475a;
    color: #fff;
  }
}
</style>

<style lang="scss" scoped>

.v-wrap {
  max-width: 1200px;
  margin: 0 auto;
  padding: 20px;

  @media screen and (min-width: 900px) {
    display: grid;
    grid-template-columns: 250px 1fr;
    grid-gap: 20px;
  }

  @media screen and (min-width: 1200px) {
    grid-gap: 30px;
  }

  @media screen and (min-width: 1600px) {
    max-width: 1600px;
  }
}

.v-photoButtons {
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: 10px;
  margin: 10px 0;
}

.v-controls {
  @media screen and (min-width: 900px) {
    padding-top: 30px;
    display: grid;
    grid-template-columns: 1fr;
    grid-template-rows: auto auto auto 1fr;
    grid-template-areas:
      "category"
      "switchImgs"
      "debug"
      "filter"
    ;
  }

  &__category {
    grid-area: category;
  }

  &__filter {
    grid-area: filter;
    @media screen and (min-width: 900px) {
      margin-top: 20px;
    }
  }

  &__switchImgs {
    grid-area: switchImgs;
  }

  &__debug {
    grid-area: debug;
  }
}

.v-favoriteLink {
  -webkit-appearance: none;
  -moz-appearance: none;
  appearance: none;
  background: transparent;
  border: 0;
  color: inherit;
  font: inherit;
  padding: 0;
  outline: 0;
  letter-spacing: inherit;
  text-align: inherit;

  font-size: 10px;
  margin: 0 8px 8px 0;
  padding: 4px 8px;
//  color: #a3a3a3;
  border-radius: 2px;

  a {
    text-decoration: none;
  }
}
</style>
